interface LoopingVideoProps {
	mp4: string // H.264 fallback (required — universal support)
	webm?: string // VP9/AV1, preferred when present (smaller)
	poster?: string // first-frame still; shown until playback starts
	alt: string // accessible label (video has no alt attribute)
	className?: string
}

// Silent autoplaying loop — the modern replacement for an animated GIF. `muted` +
// `playsInline` are what let mobile browsers autoplay; `preload="metadata"` fetches
// only enough to show the poster, deferring the payload until it scrolls into view.
// WebM is listed first so capable browsers take the smaller file; MP4 is the fallback.
export default function LoopingVideo({ mp4, webm, poster, alt, className }: LoopingVideoProps) {
	return (
		<video
			autoPlay
			muted
			loop
			playsInline
			preload="metadata"
			poster={poster}
			aria-label={alt}
			className={`block h-auto w-full ${className ?? ''}`}
		>
			{webm && <source src={webm} type="video/webm" />}
			<source src={mp4} type="video/mp4" />
		</video>
	)
}

LoopingVideo.defaultProps = {
	webm: undefined,
	poster: undefined,
	className: undefined,
}
